//import { useState } from "react";
import SampleSelection90daysController from "./SampleSelection90daysController";
//import Select from "react-select";
import {
  Box,
  CircularProgress,
  TextField,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Close } from "@mui/icons-material";

function SampleSelection90days() {
  const {
    barcodeData,
    monthList,
    updateQuantity,
    submitSampleRequest,
    openRemarkDialog,
    setOpenRemarkDialog,
    remark,
    setRemark,
    submitRemark,
    remarkError,
    openReportDialog,
    setOpenReportDialog,
    reportData,
    financialYears,
    getMonthYearWiseData,
    loadingInlineReports,
    loadingReportDialog
  } = SampleSelection90daysController();

  const shouldRenderTable = barcodeData && barcodeData.length > 0;
  const toShortFY = (fy) => {
    const v = String(fy || "").trim();
    const m = v.match(/^(\d{4})\s*-\s*(\d{4})$/);
    if (m) return `${m[1].slice(2)}-${m[2].slice(2)}`;
    return v;
  };

  return (
    <div className="bg" style={{ display: "block" }}>
      <div className="cutrange">
        <span className="font20">SAMPLE SELECTION SALES PLANNING</span>
      </div>

      {shouldRenderTable && (
        <Paper elevation={2} sx={{ width: "100%", mb: 2, overflow: "hidden", borderRadius: 2, border: "1px solid #c4ceda" }}>
          <Box sx={{ px: 2, py: 1.25, display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #e5e7eb" }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#111827" }}>
              Sample Plan Items ({barcodeData.length})
            </Typography>
            {loadingInlineReports && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: "#64748b" }}>
                <CircularProgress size={16} />
                <Typography variant="caption">Loading report quantities</Typography>
              </Box>
            )}
          </Box>
          <TableContainer sx={{ maxHeight: "calc(100vh - 260px)", overflowX: "hidden" }}>
            <Table stickyHeader size="small" aria-label="Sample selection planning quantities"
              sx={{ width: "100%", minWidth: 0, tableLayout: "fixed", borderCollapse: "collapse", "& th, & td": { px: { xs: 0.75, sm: 1.25 }, py: 1, overflowWrap: "anywhere", border: "1px solid #d3dbe6" }, "& th": { borderColor: "#bfcbd8", borderBottomWidth: 2 } }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: "29%", fontWeight: 700, bgcolor: "#eef2f7", color: "#111827" }}>Material</TableCell>
                  <TableCell sx={{ width: "12%", fontWeight: 700, bgcolor: "#eef2f7", color: "#111827" }}>Month</TableCell>
                  <TableCell sx={{ width: "16%", fontWeight: 700, bgcolor: "#eef2f7", color: "#111827" }}>Planned Qty</TableCell>
                  <TableCell align="center" sx={{ width: "21.5%", fontWeight: 700, bgcolor: "#eef2f7", color: "#111827" }}>
                    {toShortFY(financialYears.currentFY || "Current FY")} Qty (Mtr)
                  </TableCell>
                  <TableCell align="center" sx={{ width: "21.5%", fontWeight: 700, bgcolor: "#eef2f7", color: "#111827" }}>
                    {toShortFY(financialYears.previousFY || "Previous FY")} Qty (Mtr)
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {barcodeData.map((item, itemIndex) => monthList.map((monthObj, monthIndex) => {
                      const key = `${monthObj.month}_${monthObj.year}`;
                      const monthWiseData = getMonthYearWiseData(item, monthObj.month);
                      return (
                        <TableRow key={`${item.id ?? itemIndex}-${key}`} hover>
                          {monthIndex === 0 && (
                            <TableCell rowSpan={monthList.length} sx={{ verticalAlign: "top", fontWeight: 700, color: "#111827", borderRight: "1px solid #e5e7eb", whiteSpace: "normal", overflowWrap: "anywhere" }}>
                              {item.materialDesc || "-"}
                            </TableCell>
                          )}
                          <TableCell sx={{ color: "#334155", fontWeight: 500 }}>{monthObj.month}</TableCell>
                          <TableCell>
                            <TextField
                              placeholder="Qty"
                              type="text"
                              variant="outlined"
                              size="small"
                              value={item.months?.[key] ?? ""}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) updateQuantity(item.id, key, value);
                              }}
                              inputProps={{ inputMode: "numeric", "aria-label": `${item.materialDesc || "Material"} ${monthObj.month} quantity` }}
                              sx={{ width: "100%", maxWidth: 110, "& .MuiOutlinedInput-root": { bgcolor: "#fff", borderRadius: 1.5 } }}
                            />
                          </TableCell>
                          <TableCell align="center" sx={{ color: "#334155", fontWeight: 600, whiteSpace: "nowrap" }}>
                            {monthWiseData.currentQty} <Typography component="span" variant="caption" sx={{ color: "#64748b" }}>({monthWiseData.currentFYMonth || "-"})</Typography>
                          </TableCell>
                          <TableCell align="center" sx={{ color: "#334155", fontWeight: 600, whiteSpace: "nowrap" }}>
                            {monthWiseData.previousQty} <Typography component="span" variant="caption" sx={{ color: "#64748b" }}>({monthWiseData.previousFYMonth || "-"})</Typography>
                          </TableCell>
                        </TableRow>
                      );
                    }))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}

      {/* FOOTER BUTTONS */}
      <div className="footer-button">
        <button style={{ marginRight: "15px" }}>Cancel</button>
        <button
          style={{ marginRight: "15px", opacity: loadingInlineReports ? 0.7 : 1, cursor: loadingInlineReports ? "not-allowed" : "pointer" }}
          onClick={submitSampleRequest}
          disabled={loadingInlineReports}
        >
          {loadingInlineReports ? "Loading..." : "Proceed"}
        </button>
      </div>

      {/* REMARK DIALOG */}
      <Dialog
        open={openRemarkDialog}
        onClose={() => setOpenRemarkDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            fontSize: "1.5rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Remarks
          <IconButton onClick={() => setOpenRemarkDialog(false)}>
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <textarea
            type="text"
            name="remark"
            value={remark}
            className="form-control inp_text"
            id="remark"
            rows={7}
            cols={50}
            onChange={(e) => setRemark(e.target.value)}
            placeholder="Write Remark Here..."
            autoFocus
          />
          {remarkError && (
            <Typography
              variant="body2"
              sx={{ color: "red", mt: 1, fontSize: "0.9rem" }}
            >
              {remarkError}
            </Typography>
          )}
        </DialogContent>

        <DialogActions sx={{ justifyContent: "end", px: 3, py: 2 }}>
          <Button
            variant="contained"
            sx={{ fontWeight: "bold" }}
            onClick={() => submitRemark()}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* REPORTS POPUP DIALOG */}
      <Dialog
        open={openReportDialog}
        onClose={() => setOpenReportDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            fontSize: "1.5rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Reports
          <IconButton onClick={() => setOpenReportDialog(false)}>
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {loadingReportDialog ? (
            <Box sx={{ py: 5, display: "flex", flexDirection: "column", alignItems: "center", gap: 1.5 }}>
              <CircularProgress size={28} />
              <Typography sx={{ color: "#4b5563", fontWeight: 500 }}>
                Report data load ho raha hai...
              </Typography>
            </Box>
          ) : (
          <Box sx={{ overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                textAlign: "center",
              }}
            >
              <thead style={{ backgroundColor: "#f5f5f5" }}>
                <tr>
                  <th style={{ border: "1px solid #ccc", padding: "10px" }}>Month</th>
                  <th style={{ border: "1px solid #ccc", padding: "10px" }}>
                    Current FY
                    <br />
                    {(toShortFY(financialYears.currentFY) || "Current FY")} Qty
                  </th>
                  <th style={{ border: "1px solid #ccc", padding: "10px" }}>
                    Previous FY
                    <br />
                    {(toShortFY(financialYears.previousFY) || "Previous FY")} Qty
                  </th>
                </tr>
              </thead>

              <tbody>
                {reportData.length > 0 ? (
                  reportData.map((item, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "10px",
                          textAlign: "left",
                          fontWeight: 600,
                        }}
                      >
                        {item.month}
                      </td>
                      <td style={{ border: "1px solid #ccc", padding: "10px" }}>
                        {item.financialYear === financialYears.currentFY ? item.quantity : "-"}
                      </td>
                      <td style={{ border: "1px solid #ccc", padding: "10px" }}>
                        {item.financialYear === financialYears.previousFY ? item.quantity : "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={3}
                      style={{
                        border: "1px solid #ccc",
                        padding: "15px",
                        textAlign: "center",
                        color: "gray",
                      }}
                    >
                      No report data available.
                    </td>
                  </tr>
                )}
              </tbody>

            </table>
          </Box>
          )}
        </DialogContent>

        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            px: 3,
            py: 2,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "flex-end", width: "auto" }}>
            <Button
              variant="contained"
              size="small"
              sx={{
                fontWeight: "bold",
                px: 3,
                py: 1,
                minWidth: "100px",
                textTransform: "none",
              }}
              onClick={() => setOpenReportDialog(false)}
            >
              Close
            </Button>
          </Box>
        </DialogActions>

      </Dialog>

    </div>
  );
}

export default SampleSelection90days;
